module.exports = __webpack_public_path__ + "static/media/banner_lcdlm2_medium@2x.6f684434.jpg";